import { useForm } from 'react-hook-form'
import { HeadingPages } from '../../../components/HeadingPages'

import { user } from '../../../helpers/user'
import { useState } from 'react'
import { CriarUsuario } from './CriarUsuario'
import { Box, Button, Flex } from '@chakra-ui/react'
import { EditarUsuario } from './EditarUsuario'

export function PermissaoLiberacao() {
  const [option, setOption] = useState('')

  const renderingOptions = {
    'criar-usuario': <CriarUsuario user={user} />,
    'editar-usuario': <EditarUsuario user={user} />,
  }

  return (
    <>
      <HeadingPages name="Permissão de Liberação" />

      <Flex justifyContent="center" gap={4} mt={3}>
        <Button
          colorScheme={option === 'criar-usuario' ? 'blue' : 'gray'}
          onClick={() => setOption('criar-usuario')}
        >
          Criar Usuário
        </Button>
        <Button
          colorScheme={option === 'editar-usuario' ? 'blue' : 'gray'}
          onClick={() => setOption('editar-usuario')}
        >
          Editar Usuário
        </Button>
      </Flex>

      <Box
        display="flex"
        flexDirection="column"
        gap={2}
        maxW="400px"
        w="100%"
        mx="auto"
        mt="10"
      >
        {renderingOptions[option]}
      </Box>
    </>
  )
}
